var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M15.8555 5L8.85547 12L15.8555 19V5Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
